(function() {

    if (window.innerWidth >= 768) {
        return;
    }
    // Get the active collection from the rendered HTML
    var activeContent = document.querySelector('.category-content.active');
    var activeTab = document.querySelector('.category-tab.active');

    // Store the active collection handle
    var activeHandle = activeContent ? activeContent.dataset.collection : null;

    // Function to switch tabs instantly
    function switchTab(handle) {
        if (!handle) return;
        
        // Remove active from all
        document.querySelectorAll('.category-tab').forEach(function(tab) {
        tab.classList.remove('active');
        });
        document.querySelectorAll('.category-content').forEach(function(content) {
        content.classList.remove('active');
        });
        
        // Add active to selected
        var selectedTab = document.querySelector('.category-tab[data-collection="' + handle + '"]');
        var selectedContent = document.querySelector('.category-content[data-collection="' + handle + '"]');
        
        if (selectedTab) selectedTab.classList.add('active');
        if (selectedContent) selectedContent.classList.add('active');
    }

    // Add click handlers to tabs immediately
    document.querySelectorAll('.category-tab').forEach(function(tab) {
        tab.addEventListener('click', function(e) {
        e.preventDefault();
        var handle = this.dataset.collection;
        switchTab(handle);
        
        // Update URL
        if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('collection', handle);
            window.history.replaceState({ collection: handle }, '', url);
        }
        });
    });

    // Handle popstate for back/forward
    window.addEventListener('popstate', function() {
        var params = new URLSearchParams(window.location.search);
        var handle = params.get('collection');
        if (handle) {
        switchTab(handle);
        }
    });

    // If URL has a collection parameter that doesn't match active, switch immediately
    var urlParams = new URLSearchParams(window.location.search);
    var urlCollection = urlParams.get('collection');

    if (urlCollection && urlCollection !== activeHandle) {
        // Check if the collection exists
        var tabExists = document.querySelector('.category-tab[data-collection="' + urlCollection + '"]');
        if (tabExists) {
        switchTab(urlCollection);
        }
    }
})();